import { Exception } from './Exception';
export class ContactFormAuthenticationException extends Exception {
  constructor(message = 'Could not authenticate you') {
    super(message);
    this.name = 'ContactFormAuthenticationException';
  }
}
